import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'pu-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TranslatePipe],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.less'],
})
export class FooterComponent {}
